import { configureStore } from '@reduxjs/toolkit';
import {
  settings,
  table,
  details,
} from './slices'
export { default as selectors } from './selectors'
export { default as actions } from './actions'
export { default as thunks } from './thunks'

const store = configureStore({
  reducer: {
    settings: settings.reducer,
    table: table.reducer,
    details: details.reducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;